import React, { useRef } from 'react'
import { Outlet } from 'react-router-dom'

import { NavBar } from '@components'
import { ROUTES, VERSION } from '@common'
import { useNavigate } from 'react-router-dom'

const NonAuthLayoutWrapper = props => {
    const navigate = useNavigate()
    const timerRef = useRef(null)

    const handleLongPress = () => {
        navigate(ROUTES.CheckoutAssistant.root)
    }

    const startPressTimer = () => {
        timerRef.current = setTimeout(() => {
            handleLongPress()
        }, 2000)
    }

    const cancelPressTimer = () => {
        if (timerRef.current) {
            clearTimeout(timerRef.current)
            timerRef.current = null
        }
    }

    return (
        <div className="dashboard-bg p-0 m-0">
            <div className="dashboard-page-content">
                <div className="d-flex flex-grow-1 flex-column">
                    <NavBar />
                    <div style={{ height: 56 }} />
                    <Outlet />
                </div>

                <div className="mt-auto">
                    <div className="text-center text-muted p-4">
                        <p className="mb-0">&copy; {new Date().getFullYear()}，Kopi Plus Pte Ltd.</p>
                        <p
                            className="text-muted opacity-50 mb-0 mt-1 no-print"
                            onTouchStart={startPressTimer}
                            onTouchEnd={cancelPressTimer}
                        >
                            v{VERSION}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default NonAuthLayoutWrapper
